import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csif(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };
return(
      <div>
      <Sides/>
    
      <Helmet>
 
 <title>Learn Free PHP If Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php if tutorial for beginners if in Php is used for making a decision.If and else can be a block statement ,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language tutorial for begineers,php if in array,php if contains string,php if and,php if string contains,php if statement,Php if for loop,end for loop Php,Php continue,Php foreach if" />
 <link rel="canonical" href="https://www.codeexampler.com/php-if" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">If statement in PHP</h1>
    <div className="first">
        <a href="/php-control-structure">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-if-else"> <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para">If Statement use for making a decision. If and else can be a block statement 
</p>



<h2 className="headings">If Syntax in PHP:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
        
              <span className="qwerty-4">If </span>
              <span className="qwerty-3">(</span>
                <span className="qwerty-10">condition</span>
              <span className="qwerty-3">)</span>
              {"\n"}
            <span className="qwerty-8"> Statement</span>
            <span className="qwerty-4">;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-Write a program to input a number and check this number is more than or equal to 100?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">&#60;?</span>
            <span className="qwerty-6"> php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">102</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty">if</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty">$</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">&#62;</span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">100</span>
            <span className="qwerty-3">) </span>
              {"\n"}
              <span className="qwerty-3"> &#123;</span>
              {"\n"} 
              <span className="qwerty-11">echo </span>
              <span className="qwerty-3">"</span>
                <span className="qwerty"> This no is</span>
              <span className="qwerty-10"> greater </span>
              <span className="qwerty-3">than </span>
              <span className="qwerty-4">100 </span>
              <span className="qwerty-3">"; </span>
              {"\n"} 
              <span className="qwerty-3"> &#125;</span>
              {"\n"} 
              <span className="qwerty-4">?&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
        
              <span className="qwerty-11">This no is </span>
              <span className="qwerty-3">greater</span>
                <span className="qwerty-10"> than</span>
              <span className="qwerty-4"> 100 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h3 className="mt-4 mh3">IF Statement in Php with multiple conditions and Learn <a href="https://www.codeexampler.com/php-switch">switch case php</a></h3>



<h2 className="headings">Q-Write a program to input a number and print greater no in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">&#60;?</span>
            <span className="qwerty-6"> php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">88</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-6">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty">$</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">&#60; </span>
            <span className="qwerty-4">500</span>
            <span className="qwerty-3">) </span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-1">echo</span>
            <span className="qwerty-3"> " </span>
            <span className="qwerty-2">This</span>
            <span className="qwerty-10"> ". </span>
            <span className="qwerty">$</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">." </span>
            <span className="qwerty-2">no is </span>
            <span className="qwerty-4">Smaller </span>
            <span className="qwerty-2">than </span>
            <span className="qwerty-4">500 </span>
            <span className="qwerty-1">"; </span>
            {"\n"}
            <span className="qwerty-3"> &#125;</span>
            {"\n"}
            <span className="qwerty-6">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty">$</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty-4">500</span>
            <span className="qwerty-3">) </span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-1">echo</span>
            <span className="qwerty-3"> " </span>
            <span className="qwerty-2">This</span>
            <span className="qwerty-10"> ". </span>
            <span className="qwerty">$</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">." </span>
            <span className="qwerty-2">no is </span>
            <span className="qwerty-4">Greater </span>
            <span className="qwerty-2">than </span>
            <span className="qwerty-4">500 </span>
            <span className="qwerty-1">"; </span>
            {"\n"}
            <span className="qwerty-3"> &#125;</span>
            {"\n"}
            <span className="qwerty-4">?&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}

            <span className="qwerty-2">This </span>
            <span className="qwerty-4">88</span>
            <span className="qwerty-2"> no is</span>
            <span className="qwerty-4"> Smaller </span>
            <span className="qwerty-2">than</span>
            <span className="qwerty-4"> 500 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

  <h1 className="mt-5">  </h1>
       
  <div className="back">
        <a href="/php-control-structure">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csif;